/**
 * Welche Hauptaktion gehört an diesen Vorgang?
 *
 * Bisher hing dort immer „Dokumente anfordern", solange kein unterschriebener
 * Verwendungsnachweis vorlag — also über fast die gesamte Laufzeit. Bei einem Vorgang, in
 * dem der Bericht fertig geschrieben ist, ist das die falsche Aufforderung: Anzufordern ist
 * nichts, zu tun wäre das Verschicken zur Unterschrift.
 *
 * Deshalb dieselbe Kette wie im Dashboard (api/src/aufgaben/aufgaben-regeln.ts), nur aus den
 * Dateien des Vorgangs gelesen: Der am weitesten fortgeschrittene zutreffende Schritt
 * gewinnt. Rechnung und Kontoauszug bleiben außen vor — die kommen am Ende und sind kein
 * Grund, den Berater zum Nachfassen zu schicken.
 */
export type VorgangsAktion =
  | 'vn_einreichen'
  | 'vn_senden'
  | 'vn_anfordern'
  | 'bericht_senden'
  | 'bericht_schreiben'
  | 'dokumente_anfordern';

const hat = (kategorien: string[], teil: string, unterschrieben: boolean): boolean =>
  kategorien.some((k) => {
    const c = k.toLowerCase();
    return c.includes(teil) && c.includes('unterschrieben') === unterschrieben;
  });

export function naechsteAktion(input: {
  kategorien: Array<string | null | undefined>;
  hatBericht: boolean;
}): VorgangsAktion {
  const kat = input.kategorien.filter((k): k is string => !!k);

  // Von hinten nach vorn — es zählt der Zustand, nicht die Reihenfolge der Ereignisse.
  if (hat(kat, 'verwendungsnachweis', true)) return 'vn_einreichen';
  if (hat(kat, 'verwendungsnachweis', false)) return 'vn_senden';
  // Bericht kam unterschrieben zurück → als Nächstes wird der VN bei der BAFA geholt.
  if (hat(kat, 'bericht', true)) return 'vn_anfordern';
  if (hat(kat, 'bericht', false)) return 'bericht_senden';
  // Ein angelegter Bericht ohne PDF heißt: Er ist noch nicht fertig geschrieben.
  if (input.hatBericht) return 'bericht_schreiben';
  return 'dokumente_anfordern';
}
